const EXPANDER_CONTAINER_CLASS = '.text-expander';
const CONTAINER_EXPANDED_CLASS = 'text-expander--expanded';
const EXPANDER_LINK_CLASS = '.text-expander__link';

export const textExpander = () => {
  const handleLinkClick = event => {
    event.preventDefault();
    const shouldExpand = event.target.dataset.shouldExpand === 'true';
    const expanderContainer = event.target.closest(EXPANDER_CONTAINER_CLASS);

    if (shouldExpand) {
      expanderContainer.classList.add(CONTAINER_EXPANDED_CLASS);
    } else {
      expanderContainer.classList.remove(CONTAINER_EXPANDED_CLASS);
    }
  };

  Array.from(document.querySelectorAll(EXPANDER_LINK_CLASS)).forEach(expanderLinkTag =>
    expanderLinkTag.addEventListener('click', handleLinkClick)
  );
};
